import { getComponentName } from '../../../helpers/componentHelpers';

export const componentName = getComponentName('new-password-internal');
